import React, { useState } from "react";
import { Container, Menu, Dropdown } from "semantic-ui-react";
import { AppIcon } from "./app-icon";
import { topMenuContent } from "./top-menu-items";
import { Link } from "gatsby";
import { FormattedMessage, useIntl } from "react-intl";
import { I18Link, I18Text } from "../i18link";

// Important note:
// HOC and generic JS function are not correctly loaded in index.html if loaded using ES6-Reexport
// You should use directly the file.
// Looks like a webpack
import { I18WithActive } from "../../components/i18link/hoc";
import { Flag } from "../flag";

const SupportDropDownInternal = ({ ...others }) => {
  const intl = useIntl();
  return (
    <Dropdown
      aria-label={intl.formatMessage({
        id: "page.support.name",
      })}
      item
      trigger={<FormattedMessage id="page.support.name" />}
      {...others}
    >
      <Dropdown.Menu>
        <Dropdown.Header>
          <FormattedMessage id="top-menu.support.license-section" />
        </Dropdown.Header>
        <Dropdown.Item as={I18Link} id="lost-key">
          <I18Text id="lost-key" />
        </Dropdown.Item>
        <Dropdown.Item as={I18Link} id="how-to-activate">
          <I18Text id="how-to-activate" />
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Header>
          <FormattedMessage id="top-menu.support.enterprise-section" />
        </Dropdown.Header>
        <Dropdown.Item as={I18Link} id="deployment">
          <I18Text autotext id="deployment" />
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Header>
          <FormattedMessage id="top-menu.support.support-section" />
        </Dropdown.Header>
        <Dropdown.Item as={I18Link} id="support">
          <FormattedMessage id="top-menu.support.help-center-entry" />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const SupportDropDown = I18WithActive({
  id: "support",
  alternateId: "lost-key",
})(SupportDropDownInternal);

const FlagItem = ({ path, locale }) => {
  return (
    <Dropdown.Item
      as={Link}
      to={path}
      onClick={() => window.localStorage.setItem("language", locale)}
    >
      <Flag locale={locale} label />
    </Dropdown.Item>
  );
};
export const TopMenu = ({ siteTitle, siteMap, locale, locales }) => {
  const [queryParam, setQueryParam] = useState();
  const intl = useIntl();

  return (
    <Menu fixed="top" size="large" className="mobile hidden" borderless>
      <Container id="top-menu-container">
        <AppIcon siteTitle={siteTitle} locale={locale} />
        {topMenuContent(siteMap, locale).map((s, index) =>
          s.id === "support" ? (
            <SupportDropDown key={`top_menu_item_${index}`} />
          ) : (
            <Menu.Item
              as={Link}
              to={s.path}
              key={`top_menu_item_${index}`}
              activeClassName="active"
            >
              {s.text}
            </Menu.Item>
          )
        )}
        <Dropdown
          aria-label={intl.formatMessage({
            id: "top-menu.languages",
          })}
          item
          trigger={<Flag locale={locale} />}
          onOpen={() => setQueryParam(window.location.search)}
        >
          <Dropdown.Menu>
            <Dropdown.Header>
              <FormattedMessage id="top-menu.languages" />
            </Dropdown.Header>
            {locales &&
              locales.map((item, index) => (
                <FlagItem
                  key={`flag_item_${index}`}
                  path={item.path + (queryParam ? queryParam : "")}
                  locale={item.locale}
                />
              ))}
          </Dropdown.Menu>
        </Dropdown>
        {/* <Menu.Menu position="right">
        <Menu.Item>
          <Button.Group>
            <Button primary as={Link} to="/signup">
              Sign-up
            </Button>

            <Button as={Link} to="/login">
              Log in
            </Button>
          </Button.Group>
        </Menu.Item>
      </Menu.Menu> */}
      </Container>
    </Menu>
  );
};
